// extracted by mini-css-extract-plugin
module.exports = {"controls":"Controls_controls__1eluf","suggestionControls":"Controls_suggestionControls__3dGgV"};